import { RRTableAction } from '../../types/table-action.type';

export interface RRITableActionOutput<T> {
  action: RRTableAction<T>;
  row?: T;
}
